<template lang="pug">
  div.n-accordion-chart-header(
    :class="!isRtl && 'order-change'"
    :style="`background-color: ${ bgColor }; color: ${ textColor }`"
    @click="selected = !selected"
  )
    template(v-if="!isRtl")
      .header--left.small-12.medium-6.large-6
        .color-bar(:class="isChild && 'color-bar--small'" :style="`background-color: ${ barColor }; width: ${ barWidth }%`")
        .text-percent(:style="textPercentStyle") {{ formatPercent(percent) }}

      .header--right.small-12.medium-6.large-6
        .text-label
          .spv-info-wrapper.info-trend {{ label }} {{ value ? `(${ formatMoney(value) })` : '' }}
            .info-overlay(v-if="infoText" :class="!openTooltip && 'hide'")
              .info-overlay__icon(
                :class="selected && 'header-info'"
                @click.stop="() => {}"
                @mouseover="openTooltip = true"
              )
                i.fo.icon-info_kreis

              .info-overlay__text(@click.stop="openTooltip = false")
                span {{ infoText }}
                i.fo.icon-verzichten_x_kreis

    template(v-else)
      .header--left.small-12.medium-6.large-6
        .text-label {{ label }} {{ value ? `(${ formatMoney(value) })` : '' }}
        .text-percent(:style="textPercentStyle") {{ formatPercent(percent) }}

      .header--right.small-12.medium-6.large-6
        .color-bar(:class="isChild && 'color-bar--small'" :style="`background-color: ${ barColor }; width: ${ barWidth }%`")

</template>

<script>
import { formatMoney, formatPercent } from '@/modules/utils';

export default {
  name: 'n-accordion-chart-header',

  props: {
    backColor: {
      type: String,
      default: '#ffffff'
    },

    color: {
      type: String,
      default: ''
    },

    parentColor: {
      type: String,
      default: ''
    },

    label: {
      type: String,
      default: ''
    },

    percent: {
      type: [Number, String],
      default: 0
    },

    maxPercent: {
      type: [Number, String],
      default: 0
    },

    value: {
      type: [Number, String],
      default: 0
    },

    infoText: {
      type: String,
      default: ''
    },

    isChild: {
      type: Boolean,
      default: false
    },

    isRtl: {
      type: Boolean,
      default: false
    },

    isDecimal: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    selected: false,
    openTooltip: false
  }),

  computed: {
    bgColor() {
      if (this.isChild) {
        return this.selected
          ? '#e9e9e9'
          : this.backColor;
      }

      return this.selected
        ? this.color
        : this.backColor;
    },

    barColor() {
      return this.selected && !this.isChild
        ? '#ffffff'
        : this.color;
    },

    barWidth() {
      if (this.maxPercent > 50) {
        return this.percent;
      }

      return this.percent * (50 / this.maxPercent);
    },

    textColor() {
      return this.selected && !this.isChild
        ? '#ffffff'
        : 'inherit';
    },

    textPercentStyle() {
      return {
        color: this.selected && !this.isChild
          ? '#ffffff'
          : this.parentColor || 'inherit',
        fontSize: this.isChild
          ? '16px'
          : '20px'
      };
    }
  },

  methods: {
    formatMoney(value) {
      return `${ formatMoney(value, 2) }$`;
    },

    formatPercent(value) {
      const decimal = this.isDecimal
        ? 2
        : 0;
      return `${ formatPercent(value, decimal) }%`;
    }
  }
};
</script>

<style lang="scss">
.n-accordion-chart-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 12px;
  width: 100%;

  .header--left,
  .header--right {
    display: flex;
    align-items: center;
  }

  .header--left {
    justify-content: flex-end;
    padding-left: 30px;

    .text-label {
      text-align: right;
    }
  }

  .header--right {
    justify-content: flex-start;
    padding-left: 30px;
  }

  .color-bar {
    display: block;
    border-radius: 12px;
    width: 100%;
    height: 24px;

    &--small {
      height: 16px;
    }
  }

  .text-percent {
    font-size: 20px;
    font-weight: bold;
    min-width: 100px;
    padding-left: 30px;
  }

  .text-label {
    font-size: 16px;
  }

  .spv-info-wrapper {
    min-width: 280px !important;

    @media screen and (max-width: 360px) {
      min-width: 250px !important;
    }
  }

  @media screen and (max-width: 640px) {
    .header--left {
      justify-content: flex-start;
      padding-bottom: 5px;

      .text-label {
        text-align: left;
      }
    }

    &.order-change {
      .header--left {
        order: 2;
        padding-bottom: 0px;
      }

      .header--right {
        order: 1;
        padding-bottom: 5px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/n-accordion-chart-header.vue